var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.99,
    height: 38.041,
    viewBox: "0 0 37.99 38.041",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checked_2_",
    "data-name": "checked (2)",
    transform: "translate(-0.301 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14937",
    "data-name": "Path 14937",
    d: "M34.145,35.1c-5.821,4.752-24,4.752-29.7,0-5.821-4.752-5.227-25.065,0-30.411s24.472-5.346,29.7,0S39.966,30.344,34.145,35.1Z",
    transform: "translate(0 -0.618)",
    fill: "#8dc640"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6596",
    "data-name": "Group 6596",
    transform: "translate(0.318 0)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14938",
    "data-name": "Path 14938",
    d: "M19.606,26.162A27.814,27.814,0,0,1,3.094,32.577C-.945,25.686-.114,8.937,4.638,4.066c4.277-4.4,17.7-5.227,25.422-2.495C31.961,9.412,28.04,19.39,19.606,26.162Z",
    transform: "translate(-0.509 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14939",
    "data-name": "Path 14939",
    d: "M92.117,122.526a2.54,2.54,0,0,1-2.138-1.069L83.326,112.9a2.709,2.709,0,1,1,4.277-3.326l4.514,5.821L102.1,102.45a2.709,2.709,0,1,1,4.277,3.326L94.255,121.457A3.107,3.107,0,0,1,92.117,122.526Z",
    transform: "translate(-75.553 -92.919)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/checked-icon.036d2d81.svg";
export { ForwardRef as ReactComponent };